import FetchFactory from './../factory';
import type {NotificationsFilter, PaginatedDataResult, User} from "~/repository/types";

class NotificationsModule extends FetchFactory {
    private RESOURCE = '/notifications';

    async get(
        filter: NotificationsFilter | undefined,
        page: number | undefined
    ) {
        if (filter === 'all') {
            filter = undefined
        }
        return this.call<PaginatedDataResult<any>>(
            'GET',
            `${this.RESOURCE}`,
            {
                filter,
                page
            }
        )
    }


}

export default NotificationsModule;